export class LocaliseServiceErrorModel {
    constructor(
        public code: string,
        public message: string
    ) {}
}
